import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  children?: ReactNode;
  className?: string;
}

export function EmptyState({ icon: Icon, title, children, className }: EmptyStateProps) {
  return (
    <div className={cn("flex flex-col items-start gap-3 px-5 py-10 sm:px-8", className)}>
      <span className="grid size-12 place-items-center rounded-full bg-primary-soft text-primary">
        <Icon className="size-6" aria-hidden="true" />
      </span>
      <h3 className="text-base font-semibold">{title}</h3>
      {children && <div className="max-w-prose text-sm text-ink-muted">{children}</div>}
    </div>
  );
}
